import { render, staticRenderFns } from "./Clover.vue?vue&type=template&id=2e20dcfa&scoped=true&"
import script from "./Clover.vue?vue&type=script&lang=js&"
export * from "./Clover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20dcfa",
  null
  
)

export default component.exports